export const PROCESSING_TASK = {
  SELECTING: Symbol("@@PROCESSING_TASK/SELECTING"),
  TRANSLATE_TRANSFORMING: Symbol(`@@PROCESSING_TASK/TRANSLATE_TRANSFORMING`),
  SCALE_TRANSFORMING1: Symbol(`@@PROCESSING_TASK/SCALE_TRANSFORMING1`),
  SCALE_TRANSFORMING2: Symbol(`@@PROCESSING_TASK/SCALE_TRANSFORMING2`),
  ROTATE_TRANSFORMING: Symbol(`@@PROCESSING_TASK/ROTATE_TRANSFORMING1`),
  // ZOOMING_AND_PANNING: ((Symbol(
  //   `@@PROCESSING_TASK/ZOOMING_AND_PANNING`
  // ): any): "@@PROCESSING_TASK/ZOOMING_AND_PANNING"),
};
